<lib-modal-layout [title]="'Manage Inspections'" [subtitle]="''" [showClose]="false">
  <p class="text-center mb-6">Cancel the current inspection or order a new one. Changes take effect when you submit.</p>
  <div class="grid grid-cols-1 md:grid-cols-3 gap-x-8">
    <lib-form-text [formControl]="inspectionNumber" [label]="'Inspection Number'" [readonly]="true"></lib-form-text>
    <lib-form-text [formControl]="status" [label]="'Status'" [readonly]="true"></lib-form-text>
    <lib-form-text [formControl]="dateOrdered" [label]="'Date Ordered'" [readonly]="true"></lib-form-text>
  </div>

  <p class="small bold mb-2">What would you like to do?</p>
  <div class="grid grid-cols-1 md:grid-cols-2 gap-4 mb-6">
    <button type="button" class="action-tile" [class.selected]="action() === ManageAction.Cancel" [disabled]="!canCancel"
      (click)="action.set(ManageAction.Cancel)">
      <lib-icon class="w-4" icon="ban"></lib-icon>
      Cancel Inspection
    </button>
    <button type="button" class="action-tile" [class.selected]="action() === ManageAction.Order" [disabled]="!canOrder"
      (click)="action.set(ManageAction.Order)">
      <lib-icon class="w-4" icon="circleplus"></lib-icon>
      Order New Inspection
    </button>
  </div>

  @if (action() === ManageAction.Cancel) {
    <lib-form-dropdown [formControl]="reason" [label]="'Reason for cancellation'" [placeholder]="'Select a reason'" [floatLabel]="'always'" [options]="reasons"></lib-form-dropdown>
    @if (reasonValue() === CancelReason.Endorsement) {
      <div class="info-box">
        <p class="bold mb-3">An endorsement was issued on this policy. Does the inspection need to be updated and re-issued?</p>
        <mat-radio-group [formControl]="confirmReissue">
          <mat-radio-button [value]="true">Yes, update and re-issue the inspection</mat-radio-button>
        </mat-radio-group>
      </div>
    }
  } @else if (action() === ManageAction.Order) {
    <div class="info-box">A new inspection will be ordered for this policy. Any open inspection should be cancelled first.</div>
  } @else {
    <div class="info-box">This inspection can't be cancelled, and the policy already has an open inspection. Manage that one instead.</div>
  }

  <div class="text-center" btnPrimary>
    <lib-button [cssType]="'btn-primary'" [icon]="'rightarrow'" [text]="submitText()" [type]="'button'"
      [disabled]="submitDisabled()" (click)="submit()"></lib-button>
    <p class="mt-4 mb-2">Not ready to update? Come back later.</p>
    <lib-button [cssType]="'btn-secondary'" [text]="'Close'" [size]="'small'" [type]="'button'"
      (click)="dialogRef.close()"></lib-button>
  </div>
</lib-modal-layout>
